import '@angular/localize/init';
export * from './lib/feature-tax-client-details.module';
export * from './lib/tax-client-details/feature-tax-client-details.component';
